
import { Component, Vue } from 'vue-property-decorator';
import { EliotModule } from '~/store/modules/eliot';

@Component
export default class ChildrenList extends Vue {

    get currentGatewayChildren() {
        return EliotModule.currentGatewayChildren || [];
    }
}
